import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BreakpointService, ProductFacetNavigationComponent, ViewModes } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';
import { CategoryPageService } from 'src/app/customServices/category-page.service';

@Component({
  selector: 'app-facet-navigation',
  templateUrl: './facet-navigation.component.html',
  styleUrls: ['./facet-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FacetNavigationComponent extends ProductFacetNavigationComponent {
  isMobile: boolean = false;
  isCategoryPresnet: any;
  isCategeoryPage: boolean;
  ViewModes: typeof ViewModes;

  private readonly destroy$ = new Subject<void>();
  constructor(protected override breakpointService: BreakpointService,
    private clpService: CategoryPageService,
    private activatedRoute: ActivatedRoute,
    public breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef) {
    super(breakpointService);

  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isCategoryPresnet = data?.['categoryCode'];
      if (this.isCategoryPresnet != undefined) {
        this.isCategeoryPage = true;
      }
      else {
        this.isCategeoryPage = false;
      }
    });
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
